import {
  EDIT_SUPPORT_MATERIAL_TYPE,
  EDIT_SUPPORT_MATERIAL_TYPE_CLEAN,
  EDIT_SUPPORT_MATERIAL_TYPE_SUCCESS,
  EDIT_SUPPORT_MATERIAL_TYPE_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  supportMaterialType: undefined,
}

const SupportMaterialTypeEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_SUPPORT_MATERIAL_TYPE:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_SUPPORT_MATERIAL_TYPE_SUCCESS:
      state = {
        ...state,
        loading: false,
        done: true,
        supportMaterialType: action.payload.supportMaterialType,
      }
      break
    case EDIT_SUPPORT_MATERIAL_TYPE_CLEAN:
      state = initialState
      break
    case EDIT_SUPPORT_MATERIAL_TYPE_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SupportMaterialTypeEdit
